import React from 'react';

import { FormattedMessage, IntlShape, MessageDescriptor } from 'react-intl';

import { CoreUtils, ReactTableTypes, ReactTableUtils, SortableTableHeader } from '@nhl/nhl-breakaway-ui';

import CommonMessages from '~/core/commonMessages';
import { Alignments } from '~/core/enums';
import { getSize } from '~/core/tableColumns/utils';
import { Player } from '~/views/pages/dotcom/player/types';

export type StatsColumnType = {
    acc: string;
    alignHeader?: Alignments;
    header: MessageDescriptor;
    meta?: ReactTableTypes.MetaType;
    size?: number;
};

export const createGenericStatsCol =
    (columnHelper) =>
    (intl: IntlShape, { acc, header, size = 60, meta = {} }: StatsColumnType) =>
        columnHelper.accessor(acc, {
            header: () => <CoreUtils.SafeFormattedMessage message={header} />,
            size: getSize(intl, header, size),
            enableSorting: false,
            meta: {
                headerStyle: { textAlign: 'center' },
                style: { textAlign: 'center' },
                ...meta,
            },
        });

export const createGenericSortableStatsCol =
    (columnHelper) =>
    (intl: IntlShape, { acc, header, size = 60, alignHeader = Alignments.center, meta = {} }: StatsColumnType) =>
        columnHelper.accessor(acc, {
            header: ({ sortedState }: ReactTableTypes.HeaderContextType<Player, unknown>) => (
                <SortableTableHeader
                    alignment={alignHeader}
                    sortIndex={sortedState?.index}
                    sortDesc={sortedState?.desc}
                >
                    <CoreUtils.SafeFormattedMessage message={header} />
                </SortableTableHeader>
            ),
            cell: (cell) =>
                cell?.getValue() === undefined ? (
                    <FormattedMessage {...CommonMessages.statsDescriptions.symbols.noInfo} />
                ) : (
                    cell.getValue()
                ),
            size: getSize(intl, header, size),
            sortingFn: ReactTableUtils.sortUndefinedAtBottom(),
            sortUndefined: false,
            meta: {
                headerStyle: { textAlign: 'center' },
                style: { textAlign: 'center' },
                ...meta,
            },
        });

export const leftPaddedColumn = (padding = 16): ReactTableTypes.MetaType =>
    ({
        className: 'left-aligned',
        headerClassName: 'left-aligned',
        headerStyle: { paddingLeft: `${padding}px` },
        style: { paddingLeft: `${padding}px` },
    } as ReactTableTypes.MetaType);
